import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { updateCourse, UPDATE_COURSE} from "../../actions/student.action"

function* handleUpdateCourse(action) {
  try {
    const { data : resData} = yield call(studentAPI.updateCourse, action.payload);
    //extract the data here     
    yield put(updateCourse.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(updateCourse.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* updateCourseSaga() {
  yield takeLatest(UPDATE_COURSE.REQUEST, handleUpdateCourse);
}

export default updateCourseSaga;
